import {NoteType} from './custom-objects';

enum NoteColor {
  white = '#FFFFFF',
  orange = '#F88E18',
  light_orange = '#f2c087',
  yellow = '#FFD100',
    blue = '#009ccd',
  light_yellow = '#ffefa7',
  light_blue = '#95d5e9',
  green = '#039d75',
  light_green = '#6dd7bc',
  red = '#e7011a',
  light_red = '#f299a3',
  grey = '#aaaaaa',
  light_grey = '#dddddd'
}

export class ColorFactory {

  private static colorMap: { [key in NoteType]: string } = {
    [NoteType.EXISTING_ELEMENT]: NoteColor.light_blue,
    [NoteType.SOLUTION_ELEMENT]: NoteColor.light_green,
    [NoteType.PROBLEM_ELEMENT]: NoteColor.light_red,
    [NoteType.PROBLEM_MISFIT]: NoteColor.light_red,
    [NoteType.RELATION_ELEMENT]: NoteColor.light_yellow,
    [NoteType.MISSING_NOTE]: NoteColor.white,
  };

  private static cardColorMap: { [id: number]: string } = {
    [1292]: this.getColorBlue(),
    [1409]: this.getColorBlue(),
    [1417]: this.getColorGrey(),
    [1433]: this.getColorRed(),
    [1446]: this.getColorRed(),
    [1455]: this.getColorBlue(),
    [1464]: this.getColorRed(),
    [1473]: this.getColorGrey(),
    [1482]: this.getColorRed(),
    [1492]: this.getColorYellow(),
    [1515]: this.getColorGreen(),
    [1665]: this.getColorGreen(),
    [1756]: this.getColorBlue(),
    [2884]: this.getColorRed(),
    [2894]: this.getColorYellow(),
    [2907]: this.getColorGreen(),
    [2968]: this.getColorBlue(),
    [2981]: this.getColorYellow(),
    [3085]: this.getColorYellow(),
    [3098]: this.getColorGreen(),
    [3142]: this.getColorGreen(),
    [3173]: this.getColorLightGreen(),
    [3194]: this.getColorBlue(),
    [3285]: this.getColorGreen(),
    [3312]: this.getColorYellow(),
    [3377]: this.getColorYellow(),
    [3755]: this.getColorYellow(),
    [5718]: this.getColorBlue(),
    [5729]: this.getColorLightGrey(),
    [5740]: this.getColorBlue(),
    [7090]: this.getColorGreen(),
    [7098]: this.getColorBlue(),
    [7106]: this.getColorRed(),
    [7115]: this.getColorBlue(),
    [7123]: this.getColorBlue(),
    [7227]: this.getColorYellow(),
    [8520]: this.getColorYellow(),
    [8528]: this.getColorYellow(),
    [8536]: this.getColorRed(),
    [8544]: this.getColorBlue(),
    [8552]: this.getColorYellow(),
    [8560]: this.getColorLightBlue(),
    [8568]: this.getColorYellow(),
    [8576]: this.getColorBlue(),
    [8584]: this.getColorOrange(),
    [8592]: this.getColorYellow(),
    [8608]: this.getColorRed(),
    [8616]: this.getColorBlue(),
    [8624]: this.getColorYellow(),
    [8632]: this.getColorLightGrey(),
    [8640]: this.getColorBlue(),
    [8656]: this.getColorYellow(),
    [8664]: this.getColorLightGreen(),
    [8680]: this.getColorBlue(),
    [8688]: this.getColorOrange(),
    [8712]: this.getColorYellow(),
    [8720]: this.getColorBlue(),
    [8740]: this.getColorBlue(),
    [8749]: this.getColorRed(),
    [8767]: this.getColorRed(),
    [35703]: this.getColorOrange(),
    [26949]: this.getColorYellow(),
    [23101]: this.getColorYellow(),
    [23187]: this.getColorBlue(),
    [23211]: this.getColorOrange(),
    [26931]: this.getColorOrange(),
    [33875]: this.getColorBlue(),
    [33933]: this.getColorBlue(),
    [34403]: this.getColorBlue(),
    [34480]: this.getColorYellow(),
    [34495]: this.getColorGreen(),
    [35141]: this.getColorGreen(),
    [38364]: this.getColorGreen(),
    [39858]: this.getColorBlue(),
    [167602]: this.getColorYellow(),
    [166903]: this.getColorLightBlue(),
    [183168]: this.getColorBlue(),
    [174222]: this.getColorBlue(),
    [66662]: this.getColorOrange(),
    [67129]: this.getColorOrange(),
    [73230]: this.getColorBlue(),
    [73244]: this.getColorOrange(),
    [235098]: this.getColorGreen(),
    [169190]: this.getColorRed(),
    [175231]: this.getColorLightRed(),
    [175239]: this.getColorBlue(),
    [175215]: this.getColorBlue(),
    [175223]: this.getColorOrange(),
    [171714]: this.getColorYellow(),
    [176363]: this.getColorRed(),
    [86746]: this.getColorLightGrey(),
    [86774]: this.getColorOrange(),
    [86801]: this.getColorYellow(),
    [86813]: this.getColorYellow(),
    [175613]: this.getColorYellow(),
    [168482]: this.getColorLightGrey(),
    [164466]: this.getColorBlue(),
    [101011]: this.getColorRed(),
    [112052]: this.getColorOrange(),
    [112066]: this.getColorBlue(),
    [211189]: this.getColorBlue(),
    [165619]: this.getColorRed(),
    [210095]: this.getColorYellow(),
    [181163]: this.getColorLightRed(),
    [182950]: this.getColorRed(),
    [183664]: this.getColorBlue(),
    [248187]: this.getColorGreen(),
    [190518]: this.getColorGrey(),
    [190437]: this.getColorGrey(),
    [190446]: this.getColorGrey(),
    [190494]: this.getColorGrey(),
    [190423]: this.getColorGrey(),
    [190533]: this.getColorGrey(),
    [190807]: this.getColorGrey(),
    [190854]: this.getColorGrey(),
    [190513]: this.getColorGrey(),
    [190770]: this.getColorGrey(),
    [190869]: this.getColorGrey(),
    [190791]: this.getColorGrey(),
    [190441]: this.getColorGrey(),
    [190457]: this.getColorGrey(),
    [190470]: this.getColorGrey(),
    [190482]: this.getColorGrey(),
    [190525]: this.getColorGrey(),
    [190506]: this.getColorGrey(),
    [190884]: this.getColorGrey(),
    [190783]: this.getColorGrey(),
    [190466]: this.getColorGrey(),
    [190840]: this.getColorGrey(),
    [190426]: this.getColorGrey(),
    [190453]: this.getColorGrey(),
    [190429]: this.getColorGrey(),
    [190498]: this.getColorGrey(),
    [190487]: this.getColorGrey(),
    [190479]: this.getColorGrey()
  };

  public static getColorForCard(id: number) {
    if (this.cardColorMap[id] === undefined) {
      // for linkageCards and all other e.g. motivation...
      return NoteColor.light_grey;
    }
    return this.cardColorMap[id];
  }

  public static getColor(type: NoteType) {
    return this.colorMap[type];
  }

  public static getColorBlue() {
    return NoteColor.blue;
  }

  public static getColorGrey() {
    return NoteColor.grey;
  }

  public static getColorLightGrey() {
    return NoteColor.light_grey;
  }

  public static getColorLightBlue() {
    return NoteColor.light_blue;
  }

  public static getColorRed() {
    return NoteColor.red;
  }

  public static getColorLightRed() {
    return NoteColor.light_red;
  }

  public static getColorGreen() {
    return NoteColor.green;
  }

  public static getColorLightGreen() {
    return NoteColor.light_green;
  }

  public static getColorYellow() {
    return NoteColor.yellow;
  }

  public static getColorLightYellow() {
    return NoteColor.light_yellow;
  }

  public static getColorOrange() {
    return NoteColor.orange;
  }

  public static getColorLightOrange() {
    return NoteColor.light_orange;
  }
}

